import { createPostEndpoint } from '@sonar-software/sonar-http';
import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

export type PostDataSecurityAccessAuditExportRequest = DynamicQueryParams & {
	salesforceId: string;
};

export type PostDataSecurityAccessAuditExportResponse = { id: number };

export const postDataSecurityAccessAuditExportStart = createPostEndpoint<
	PostDataSecurityAccessAuditExportRequest,
	PostDataSecurityAccessAuditExportResponse
>(({ salesforceId }) => `/api/v3/core/exports/data-access/who-has-access/${salesforceId}/export/start`);
